export const errorContainerStyles = {
  width: '94%',
  py: '32vh',
  alignContent: 'center',
  textAlign: 'center',
};

export const tableContainerStyles = {
  width: '100%',
  backgroundColor: '#fff',
  p: '2rem',
};
